// extracted by mini-css-extract-plugin
module.exports = {"duelInProgress":"DuelInProgress_duelInProgress__24njx","message":"DuelInProgress_message__S8lif"};